import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PartnerService } from '@principle-theorem/ng-principle-shared';
import { Partner } from '@principle-theorem/principle-core';
import { type IPartnerApp } from '@principle-theorem/principle-core/interfaces';
import {
  doc,
  filterUndefined,
  Firestore,
  type ResolverResult,
  type WithRef,
} from '@principle-theorem/shared';
import { switchMap } from 'rxjs/operators';

@Injectable()
export class PartnerAppResolver {
  constructor(private _partner: PartnerService) {}

  resolve(
    activatedRoute: ActivatedRouteSnapshot
  ): ResolverResult<WithRef<IPartnerApp>> {
    return this._partner.partner$.pipe(
      filterUndefined(),
      switchMap((partner) => {
        if (!partner) {
          throw new Error(`Can't find partner`);
        }

        const uid: string = activatedRoute.paramMap.get('uid') || '';
        return Firestore.getDoc(doc(Partner.appCol(partner), uid));
      })
    );
  }
}
